import { IResidentialComplex } from '../../types/residentials';
import { IApplicationState } from '../../types/redux';

export function getResidentialComplexById(state: IApplicationState, id: number): IResidentialComplex {
  const {
    residentialComplexes: { hash },
  } = state;

  return hash[id];
}
